import React, { useState, useEffect, useRef } from "react";
import "./tableStyle.css";
import { reportsApi } from "../../Services/Services";
import { Col, Input, Button, Radio, Form, Select } from "antd";
import { useReactToPrint } from "react-to-print";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import * as XLSX from "xlsx"; // Import xlsx library
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

const { Option } = Select;

export default function SaleDoList({ onChange }) {
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(50); // batch size
  const [hasMore, setHasMore] = useState(true);
  const [form] = Form.useForm();
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2022 }, (_, i) => 2023 + i);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  useEffect(() => {
    resetAndLoad();
  }, [selectedYear]);

  const resetAndLoad = async () => {
    setOffset(0);
    setHasMore(true);
    const response = await fetchData(0);
    if (response) {
      setDeliveryOrder(response);
      setOrderList(response);
      setOffset(limit);
    }
  };

  const fetchData = async (offset) => {
    const response = await reportsApi({
      report_name: "sale_do",
      com_name: localStorage.getItem("com_name"),
      offset,
      limit,
    });

    return response.results || [];
  };

  const loadMoreData = async () => {
    if (!hasMore) return;
    const newData = await fetchData(offset);
    if (newData.length > 0) {
      setDeliveryOrder((prev) => [...prev, ...newData]);
      setOrderList((prev) => [...prev, ...newData]);
      setOffset(offset + limit);
      if (newData.length < limit) setHasMore(false);
    } else {
      setHasMore(false);
    }
  };

  const handleValuesChange = (changedValues, allValues) => {
    const filteredData = orderList.filter(
      (item) =>
        item.client_name
          .toLowerCase()
          .includes((allValues.client_name || "").toLowerCase()) &&
        item.do_no.toLowerCase().includes((allValues.do_no || "").toLowerCase())
    );

    setDeliveryOrder(filteredData);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = deliveryOrder.map((e, index) => [
      index + 1,
      e.client_name,
      e.do_no,
      e.mines_name,
      e.do_start_date,
      e.do_end_date,
      e.quantity,
      e.dis_qty,
      e.rem_qty,
      e.total_advance_paid,
      e.advance_amt,
      parseFloat(e.total_advance_paid) - parseFloat(e.advance_amt),
      e.paid_amt,
      e.rem_qty != 0 ? "Pending" : "Complete",
      e.sell_qty,
      e.is_bill ? "Yes" : "No",
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        "Sr. No",
        "Party Name",
        "Do No.",
        "Mines Name",
        "DO Start Date",
        "DO End Date",
        "Total Qty",
        "Dispatch Qty",
        "Balance Qty",
        "Debit Amount",
        "Credit Amt",
        "Balance Amt",
        "Total Freight Amount",
        "Lifting Status",
        "Sale Qty",
        "Bill Status",
      ],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "DeliveryOrder");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, "Sale Do List.xlsx");
  };
  const searchFilter = (value) => {
    if (value) {
      const filteredArray = orderList.filter((item) => item.rem_qty === 0);
      setDeliveryOrder(filteredArray);
    } else if (value === "") {
      setDeliveryOrder(orderList);
    } else {
      const filteredArray = orderList.filter((item) => item.rem_qty != 0);
      setDeliveryOrder(filteredArray);
    }
  };

  const formateDate = (date) => {
    const [year, month, day] = date.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };

  const getYearsArray = (startYear, endYear) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };
  return (
    <div>
      <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
        <div
          className=" grid grid-cols-1 sm:grid sm:grid-cols-5 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]"
          style={{ marginBottom: "10px" }}
        >
          <Col>
            <label>
              <b>Select Year</b>
            </label>
            <br />
            <Select
              value={selectedYear} // <-- Set current year as selected
              onChange={(value) => setSelectedYear(value)} // <-- Allow user to change
              showSearch
              style={{ width: "95%", marginLeft: "2%", marginRight: "2%" }}
              placeholder="Select Year"
            >
              {years.map((year) => (
                <Option value={year}>{year}</Option>
              ))}
            </Select>
          </Col>

          <Col>
            <label>
              <b>Search By Do No.</b>
            </label>
            <br />
            <Form.Item name="do_no">
              <Input placeholder="Search by DO No." />
            </Form.Item>
          </Col>
          <Col>
            <label>
              <b>Search By Party Name</b>
            </label>
            <br />
            <Form.Item name="client_name">
              <Input placeholder="Search by Party Name." />
            </Form.Item>
          </Col>

          <Col>
            <label>
              <b>Lifting Status </b>
            </label>
            <Radio.Group defaultValue={""}>
              <Radio value={false} onChange={(e) => searchFilter(false)}>
                Pending
              </Radio>
              <Radio value={true} onChange={(e) => searchFilter(true)}>
                Complete
              </Radio>
              <Radio value={""} onChange={(e) => searchFilter("")}>
                All
              </Radio>
            </Radio.Group>
          </Col>

          <Col>
            <Button
              style={{
                bottom: "-5px",
                margin: "10px",
                backgroundColor: "black",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handlePrint}
            >
              <FaFilePdf />
            </Button>
            <Button
              style={{
                bottom: "-5px",
                margin: "10px",
                backgroundColor: "green",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handleExportToExcel}
            >
              <FaFileExcel />
            </Button>
            {/* <Button
            style={{

              margin: "10px",
              backgroundColor: 'green',
              color: 'white',
              fontWeight: '600'
            }}
            onClick={onChange('')}
          >
            Close
          </Button> */}
          </Col>
        </div>
      </Form>
      <div className="table-wrapper-3" ref={componentRef}>
        <table id="my-table" className="w-full">
          {/* <div className="table-container"  ref={componentRef}>
        <table id="my-table" className="w-full relative"> */}
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sr. No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Id
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Party Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Do No.
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Mines Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                DO Start Date
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                DO End Date
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Total Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Dispatch Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Balance Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                {" "}
                Debit Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Credit Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Balace Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Total Freight Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Lifting Status
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sale Qty
              </th>

              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Bill
              </th>
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.map((e, index) => (
              <tr key={e.index}>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {index + 1}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.id}
                </td>

                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.client_name}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.do_no}
                    </u>
                  </Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.mines_name}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.do_start_date)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.do_end_date)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.quantity}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.dis_qty.toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.rem_qty.toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.total_advance_paid}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.advance_amt}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {parseFloat(e.total_advance_paid) - parseFloat(e.advance_amt)}
                </td>

                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.paid_amt}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.rem_qty != 0 ? "Pending" : "Complete"}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.sell_qty.toFixed(3)}
                </td>

                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.is_bill ? "Yes" : "No"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <InfiniteScroll
          dataLength={deliveryOrder.length}
          next={loadMoreData}
          hasMore={hasMore}
          loader={
            deliveryOrder.length > 0 && hasMore ? (
              <div style={{ textAlign: "center", padding: "10px" }}>
                Loading...
              </div>
            ) : null
          }
          scrollableTarget="scrollableDiv"
        />
      </div>
    </div>
  );
}
